// extracted by mini-css-extract-plugin
export default {"observepointLogo":"observepoint-modal_observepointLogo__gw-ef","link":"observepoint-modal_link__FrmuS","scanTooltip":"observepoint-modal_scanTooltip__-B+Qs"};